import React from 'react';
import { PhoneIcon, MailIcon, CalendarIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import { contact, hasPhone, hasEmail, hasBooking, hasAnyContact } from '../../data/contact';
import { trackEvent } from '../../utils/analytics';
type Props = {
  /** Where the links are shown, sent with the tracking event */
  location: string;
  variant?: 'stack' | 'inline';
  className?: string;
};

/** Phone, email and booking links. Renders nothing until at least one is configured. */
export function ContactLinks({
  location,
  variant = 'stack',
  className = ''
}: Props) {
  const {
    t
  } = useLanguage();
  if (!hasAnyContact()) return null;
  const item = 'inline-flex items-center gap-2 font-sans text-sm text-[#121212]/75 hover:text-[#4F46E5] transition-colors';
  const icon = 'w-4 h-4 shrink-0';
  const wrap = variant === 'inline' ? 'flex flex-wrap items-center gap-x-6 gap-y-2' : 'flex flex-col items-start gap-3';
  return <div className={`${wrap} ${className}`} data-id="element-2983" data-mp="13gfwzlvoeey3">
      {hasPhone() && <a href={`tel:${contact.phone}`} className={item} onClick={() => trackEvent('contact_click', {
      method: 'phone',
      location
    })} data-id="element-2984" data-mp="2bpm64qob871u">
          <PhoneIcon className={icon} strokeWidth={1.75} data-id="element-2985" data-mp="2gps0wfpvm9o5" />
          {contact.phoneLabel}
        </a>}
      {hasEmail() && <a href={`mailto:${contact.email}`} className={item} onClick={() => trackEvent('contact_click', {
      method: 'email',
      location
    })} data-id="element-2986" data-mp="26xmc1eux88d6">
          <MailIcon className={icon} strokeWidth={1.75} data-id="element-2987" data-mp="1sxbiu5652hou" />
          {contact.email}
        </a>}
      {hasBooking() && <a href={contact.bookingUrl} target="_blank" rel="noopener noreferrer" className={item} onClick={() => trackEvent('contact_click', {
      method: 'booking',
      location
    })} data-id="element-2988" data-mp="1xv380rfefppc">
          <CalendarIcon className={icon} strokeWidth={1.75} data-id="element-2989" data-mp="3ebpga48ylyvv" />
          {t('Book a call', 'Réserver un appel')}
        </a>}
    </div>;
}